import styled from '@emotion/styled'

interface FavoriteButtonProps {
	isFavorite: boolean
	onClick: (e: React.MouseEvent) => void
	className?: string
	style?: React.CSSProperties
	/** 'overlay' agrega un fondo circular blanco con sombra, pensado para ir superpuesto sobre una imagen (ej. tarjeta desktop) */
	variant?: 'plain' | 'overlay'
}

const HeartIcon = ({ filled }: { filled: boolean }) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill={filled ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
		<path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
	</svg>
)

export const FavoriteButton = ({ isFavorite, onClick, className, style, variant = 'plain' }: FavoriteButtonProps) => (
	<Button
		type="button"
		className={className}
		style={style}
		$isFavorite={isFavorite}
		$variant={variant}
		onClick={onClick}
		aria-label={isFavorite ? 'Quitar de favoritos' : 'Agregar a favoritos'}
		aria-pressed={isFavorite}
	>
		<HeartIcon filled={isFavorite} />
	</Button>
)

const Button = styled.button<{ $isFavorite: boolean; $variant: 'plain' | 'overlay' }>`
	display: flex;
	align-items: center;
	justify-content: center;
	border: none;
	cursor: pointer;
	color: ${({ $isFavorite }) => ($isFavorite ? '#ff4d6d' : '#bbb')};
	transition: color 0.15s, transform 0.1s;

	${({ $variant }) => $variant === 'overlay' ? `
		background: rgba(255, 255, 255, 0.9);
		border-radius: 50%;
		width: 32px;
		height: 32px;
		box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
	` : `
		background: none;
		padding: 0;
	`}

	&:active {
		transform: scale(0.9);
	}
`
